'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';

const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID || 'dev';

type ServiceWorkerLog = { type: 'sw-log'; level: 'info' | 'warn' | 'error'; message: string };

function isServiceWorkerLog(data: unknown): data is ServiceWorkerLog {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { type?: unknown }).type === 'sw-log' &&
    typeof (data as { message?: unknown }).message === 'string'
  );
}

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const onMessage = (event: MessageEvent) => {
      if (!isServiceWorkerLog(event.data)) return;
      const level =
        event.data.level === 'error' || event.data.level === 'warn' ? event.data.level : 'info';
      logger[level]('[ServiceWorker]', event.data.message);
    };
    navigator.serviceWorker.addEventListener('message', onMessage);

    navigator.serviceWorker.register(`/sw.js?v=${BUILD_ID}`).catch((error) => {
      logger.warn('[ServiceWorker]', 'registration failed', error);
    });

    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, []);

  return null;
}
